var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatermarkItBb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1709.22 243.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2c7be5;}.cls-2{fill:#165bb6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.36,0,152.21,69.61H101.93L105.8,47H85.08L76.52,96.68h64.64l-52.49,47H68.23L50.55,243.37H0L37,34,15.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.52,218.5,194.19,23.76h67.13l-1.1,194.74H216.57l-.28-18.5-34.8-47.24h36.74L219.61,79l-.55-5.52L195,145.3H165.47l20.16,29L170.44,218.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.17,218.5,307.73,50.83,290.32,23.76h60.5l20.72,78.45,13.81-78.45h40.33l-34,192.53L368.78,237,335.35,123.48l-16.85,95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562.42,79.56H522.36l3-18.23H515.18L487.55,218.5H447L474.57,61.33H455.79L430.93,23.76H572.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M537.28,218.5,605,23.76h67.12L671,218.5H627.33l-.27-18.5-34.81-47.24H629L630.37,79l-.55-5.52-24,71.82H576.23l20.16,29L581.2,218.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M732.85,0H854.4A7.53,7.53,0,0,1,859,1.8a20.33,20.33,0,0,1,4.15,4.28,21,21,0,0,1,2.76,5.25,10.29,10.29,0,0,1,.69,4.69l-16,91.44L806.05,74,810.75,47H774.84L748.6,196.41h35.91l8.84-50.28,44.47,33.7L826.5,243.37H705a7,7,0,0,1-4.42-1.8,26,26,0,0,1-4.14-4.28,18.39,18.39,0,0,1-2.9-5.25,10,10,0,0,1-.69-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M873.46,23.76h62.43L908.26,180.94h16.58l3.31-18.23h40.33l-9.94,55.79H861.3L890.86,50.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M978.7,218.5l67.68-194.74h67.12l-1.1,194.74h-43.65l-.27-18.5-34.81-47.24h36.74L1071.79,79l-.55-5.52-24,71.82h-29.56l20.17,29-15.2,44.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1238.92,218.5H1141.4a6.52,6.52,0,0,1-3.86-1.38,13.16,13.16,0,0,1-3.32-3.45,16.54,16.54,0,0,1-2.07-4.28,8.36,8.36,0,0,1-.41-3.87l12.7-71.82,35.64,26.52-3.59,20.72h28.45l4.42-25.14-59.94-50.28,14.36-81.76H1261a6.63,6.63,0,0,1,3.86,1.38,13.32,13.32,0,0,1,3.32,3.45,16.7,16.7,0,0,1,2.07,4.28,8.37,8.37,0,0,1,.41,3.87l-11.87,67.13-35.64-26.52,2.76-16h-28.45l-3,18.5,60,50.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1374.82,218.5h-97.51a6.57,6.57,0,0,1-3.87-1.38,13.12,13.12,0,0,1-3.31-3.45,16.23,16.23,0,0,1-2.07-4.28,8.38,8.38,0,0,1-.42-3.87l12.71-71.82L1316,160.22l-3.59,20.72h28.46l4.42-25.14-60-50.28,14.37-81.76h97.23a6.64,6.64,0,0,1,3.87,1.38,13.12,13.12,0,0,1,3.31,3.45,17.08,17.08,0,0,1,2.08,4.28,8.64,8.64,0,0,1,.41,3.87l-11.88,67.13-35.63-26.52,2.76-16h-28.45l-3,18.5,59.94,50.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1533.66,23.76,1524,79.56h-40.33l3-18.23h-16.58l-6.9,39.77h51.65l-41.71,37.57h-16.57l-7.46,42.27h16.57l3.32-18.23h40.33l-9.95,55.79h-97.23l29.55-167.67-17.4-27.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1551.9,193.84l-4.32,24.66H1521.3l4.32-24.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1573.14,91.6h40.68L1591.5,218.5h-26.28l19.26-109.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1702.92,128h-26.1l2-11.88h-6.66l-18,102.42h-26.46l18-102.42h-12.24l-16.2-24.48h92Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkItBb);
export default __webpack_public_path__ + "static/media/watermark-it-bb.bf786cbf8d7b2a68f9fd29affb54f6d0.svg";
export { ForwardRef as ReactComponent };